import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal,
  inject,
  HostListener,
  HostBinding
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { ToggleButtonGroupComponent } from '../toggle-button-group.component';

@Component({
  selector: 'zui-toggle-button',
  templateUrl: './toggle-button.component.html',
  styleUrl: './toggle-button.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule
  ]
})
export class ToggleButtonComponent {
  // # Deps
  #group = inject(ToggleButtonGroupComponent, { optional: true });

  // # Inputs
  value = input.required<any>();
  disabled = input<boolean>(false);

  // # State
  isActive = signal<boolean>(false);

  // # Host bindings
  @HostBinding('class.is-active')
  get activeClass() {
    return this.isActive();
  }

  @HostBinding('class.is-disabled')
  get disabledClass() {
    return this.disabled();
  }

  // # Methods
  @HostListener('click')
  onClick() {
    if (this.#group && !this.disabled()) {
      this.#group.selectValue(this.value());
    }
  }

  setActive(active: boolean) {
    this.isActive.set(active);
  }
}
